import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=17748127&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSlideXReverseTransition } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTimePicker } from 'vuetify/lib'
installComponents(component, {VApp,VAutocomplete,VBtn,VCard,VDatePicker,VDivider,VFlex,VForm,VLayout,VMenu,VSlideXReverseTransition,VTextField,VTimePicker})
